import { mapper } from '@shared/lib';

type MapHeaderLogo = (data: any) => {
  variant1SizeImgSrc: Url;
  variant2SizeImgSrc: Url;
};
export const mapLogo: MapHeaderLogo = mapper([
  { name: 'variant1SizeImgSrc', from: 'variant1SizeImg.data.attributes.url' },
  { name: 'variant2SizeImgSrc', from: 'variant2SizeImg.data.attributes.url' },
]);